<template>
  <li class="octadesk-chat-survey">
    <ConversationMessageThumb :user="agent"></ConversationMessageThumb>

    <div class="octadesk-chat-survey-body">
      <div
        class="survey-buttons-container"
        :class="[surveyModel.response ? 'answered' : '']"
      >
        <div>
          <p class="survey-buttons-title" v-html="surveyTitle" />

          <div class="survey-options">
            <label class="survey-options-item">
              <input
                v-model="surveyModel.response"
                type="radio"
                name="surveyOption"
                class="survey-options-item-input"
                value="unsatisfied"
              />

              <div class="survey-options-item-img-out">
                <img
                  src="@/css/images/survey/down-gray.svg"
                  alt=""
                  width="48px"
                  height="48px"
                />
              </div>

              <div class="survey-options-item-img-over">
                <img
                  src="@/css/images/survey/down-color.svg"
                  alt=""
                  width="48px"
                  height="48px"
                />
              </div>
            </label>

            <label class="survey-options-item">
              <input
                v-model="surveyModel.response"
                type="radio"
                name="surveyOption"
                class="survey-options-item-input"
                value="satisfied"
              />

              <div class="survey-options-item-img-out">
                <img
                  src="@/css/images/survey/up-gray.svg"
                  alt=""
                  width="48px"
                  height="48px"
                />
              </div>

              <div class="survey-options-item-img-over">
                <img
                  src="@/css/images/survey/up-color.svg"
                  alt=""
                  width="48px"
                  height="48px"
                />
              </div>
            </label>
          </div>

          <p class="survey-textarea-title">
            <span v-html="$sanitizeHtml($t('survey.commentTitle'))" />
          </p>

          <div
            class="survey-textarea-wrapper"
            :style="`border-color: rgba(${settings.bgColorRGBA});`"
          >
            <textarea
              ref="survey_comment"
              v-model="commentModel.comment"
              rows="1"
              :placeholder="$t('survey.messagePlaceholder')"
              @keyup="autoExpandTextarea()"
              @keypress.enter="handleSendSurvey($event)"
              @focus="isCommentFocused = true"
            />
          </div>

          <div class="survey-btns">
            <div class="survey-btn">
              <a
                v-if="!surveyModel.response"
                href="#"
                :style="`color: rgba(${settings.bgColorRGBA});`"
                class="no-decoration"
                @click="handleNotAnswered"
              >
                {{ $t('survey.notAnsweredTitle') }}
              </a>
            </div>

            <button
              type="button"
              class="survey-btn survey-send-btn"
              :style="`color: ${
                surveyModel.response
                  ? 'rgba(' + settings.fontColorRGBA + ')'
                  : '#ffffff !important'
              }; background-color: rgb(${settings.bgColorRGB});`"
              :disabled="!surveyModel.response"
              @click="handleSendSurvey"
            >
              {{ $t('survey.send') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import ConversationMessageThumb from '@/app/conversation/components/events/message/ConversationMessageThumb'

  export default {
    components: {
      ConversationMessageThumb
    },
    props: ['value'],
    data() {
      return {
        surveyModel: {
          response: undefined,
          responseTime: undefined
        },
        commentModel: {
          comment: ''
        },
        container: null,
        isCommentFocused: false
      }
    },
    computed: {
      ...mapGetters(['fluxSurvey', 'settings', 'agent']),
      dynamicColors() {
        return {
          '--button-active-bg': `rgba(${this.settings.bgColorRGBA})`,
          '--button-active-color': `rgba(${this.settings.fontColorRGBA})`
        }
      },
      baseScrollHeight() {
        return this.$refs.survey_comment.scrollHeight
      },
      surveyTitle() {
        if (this.fluxSurvey && this.fluxSurvey.title) {
          return this.$sanitizeHtml(this.fluxSurvey.title)
        }

        return this.$sanitizeHtml(this.$t('survey.title'))
      }
    },
    mounted() {
      this.surveyOpen()
    },
    updated() {
      if (this.surveyModel.response) {
        this.container = document.querySelector('.survey-textarea-container')
      }
    },
    methods: {
      ...mapActions([
        'sendSurvey',
        'surveyOpen',
        'sendComment',
        'setSurveyFinished'
      ]),
      isMyMessage(message) {
        if (message) {
          return message.user.email === this.message.user.email
        }
        return false
      },
      handleSendSurvey(event) {
        if (event && event.shiftKey) {
          event.preventDefault()
        } else {
          if (this.surveyModel.response) {
            this.surveyModel.responseTime = new Date()

            this.sendSurvey(this.surveyModel)
              .then(() => {
                if (this.commentModel.comment) {
                  this.sendComment(this.commentModel)
                    .then(() => {
                      this.$emit('surveyCompleted', true)
                      this.setSurveyFinished(true)
                    })
                    .catch(error => error && console.error(error))
                } else {
                  this.$emit('surveyCompleted', true)
                  this.setSurveyFinished(true)
                }
              })
              .catch(error => error && console.error(error))
          }
        }
      },
      handleNotAnswered() {
        this.surveyModel.response = 'not_answered'
        this.surveyModel.responseTime = new Date()

        this.sendSurvey(this.surveyModel).catch(err => {
          if (err) {
            console.error(err)
          }
        })
        this.$emit('surveyCompleted', true)
        this.setSurveyFinished(true)
      },
      autoExpandTextarea() {
        let minRows = 1

        let maxRows = 3

        let computed

        if (!this.$refs.survey_comment) return false

        this.$refs.survey_comment.rows = minRows

        let rows = Math.ceil(
          (this.$refs.survey_comment.scrollHeight - this.baseScrollHeight) / 23
        )

        computed = minRows + rows < maxRows ? minRows + rows : maxRows

        this.$refs.survey_comment.rows = computed
      }
    }
  }
</script>

<style lang="scss">
  .survey {
    &-options {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 20px;

      &-item {
        position: relative;
        transition: 200ms transform;

        &:not(.static) {
          cursor: pointer;
        }

        &:not(.static) &-img {
          &-out {
            position: absolute;
            transition: 200ms opacity;
          }

          &-over {
            opacity: 0;
            transition: 200ms opacity;
          }
        }

        &-input {
          display: none;
        }

        &:not(.static):hover &-img-out,
        &-input:checked + &-img-out {
          opacity: 0;
        }

        &:not(.static):hover &-img-over,
        &-input:checked + &-img-out + &-img-over {
          opacity: 1;
        }

        &:not(.static):active {
          transform: scale(0.9);
        }
      }

      &-item + &-item {
        margin-left: 32px;
      }
    }

    &-btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 16px;
    }

    &-btn {
      display: inline-flex;

      a.no-decoration:hover {
        text-decoration: underline !important;
      }
    }

    &-send-btn {
      background-color: #0074ff;
      border-radius: 20px;
      padding: 8px 24px;
      color: #ffffff;
      font-size: 12px;
      cursor: pointer;

      &:disabled {
        background-color: #bbbbbb !important;
        opacity: 0.5;
      }
    }

    &-ok-icon-block {
      display: flex;
      justify-content: center;
      margin-bottom: 8px;
    }
  }

  .octadesk-chat-survey {
    position: relative;
    width: 100%;
    margin: 1.5rem auto;
    font-size: 0.875rem;
    color: #6a6a6a;
  }

  .octadesk-chat-survey-body {
    float: right;
    width: calc(100% - (30px + 0.3125rem));
    min-height: 235px;
    margin: 0 0 1.5rem 0;
    font-size: 0.875rem;
  }

  .survey-buttons-container,
  .survey-textarea-container {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }

  .survey-buttons-container {
    width: 100%;
    background: #fff;
    padding: 20px;
    margin: 0 0 0.235rem 0;
    font-size: 0.875rem;
    border-radius: 5px 30px 30px 30px;
  }

  .survey-buttons-container.answered {
    margin-bottom: 10px;
    border-radius: 5px 30px 30px 0px;
  }

  .survey-textarea-container {
    width: 100%;
    background: #fff;
    padding: 0.5rem 0.95rem;
    margin: 0 0 0.5rem 0;
    font-size: 0.875rem;
    border-radius: 5px 30px 30px 30px;
  }

  .survey-buttons-title,
  .survey-textarea-title {
    font-size: 14px;
    text-align: center;
    color: #6a6a6a;
    font-weight: 400;
    margin: 0px;
  }
  .survey-buttons-title strong {
    font-weight: 700;
  }

  .survey-textarea-title span {
    position: relative;
    display: inline-block;
    height: 24px;
    line-height: 24px;
  }

  .survey-textarea-title span svg {
    position: absolute;
    left: 0;
  }

  .survey-textarea-wrapper {
    position: relative;
    width: 100%;
    min-height: 16px;
    max-height: 9.375rem;
    margin: 0 auto 0.5rem auto;
    border: none !important;
    margin-top: 10px;
  }

  .survey-textarea-wrapper textarea {
    width: 100%;
    margin: 0 auto;
    height: 72px;
    background: transparent;
    border: none;
    resize: none;
    outline: none;
    overflow: hidden;
    box-sizing: border-box;
    font: normal 0.75rem Arial, Helvetica, sans-serif;
    color: currentColor;
    white-space: pre-wrap;
    word-wrap: break-word;
    border-radius: 10px;
    padding: 12px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }

  .survey-textarea {
    resize: none;
    min-height: 80px;
    max-height: 40%;
  }

  .pull-right {
    float: right !important;
  }

  .bg-gray {
    background: #eee;
  }

  .text-primary {
    color: #5da9dd;
  }

  .text-success {
    color: #50b848 !important;
  }

  .space-top-xs {
    margin-top: 6px;
  }

  button:disabled,
  textarea:disabled {
    cursor: not-allowed;
  }

  .no-selectable {
    pointer-events: none;
  }

  .slideup-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slideup-fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  }
  /* .slideup-fade-leave-active em versões anteriores a 2.1.8 */
  .slideup-fade-enter,
  .slideup-fade-leave-to {
    transform: translateY(10px);
    opacity: 0;
  }
</style>
